import logo from './logo.svg';
import './App.css';
import CPUSchedulerVisualizer from './components/CPUSchedulerVisualizer';
function App() {
  return (
    <div>
      <CPUSchedulerVisualizer />
    </div>
  );
}

export default App;
